import { memo } from 'react';
import { useChatConfig, useNumberOfTurns } from '../Chat/hooks/ChatStore.hooks';
import { Tooltip } from '@scale/scaleui';

interface InfoTurnsProps {
  additionalMinutesPerTurn?: number;
}

function InfoTurns({ additionalMinutesPerTurn }: InfoTurnsProps) {
  const { minTurns, maxTurns } = useChatConfig();
  const numTurns = useNumberOfTurns();

  if (!maxTurns || !minTurns) {
    return null;
  }

  const hasAdditionalMinutesPerTurn = additionalMinutesPerTurn && additionalMinutesPerTurn > 0;
  const turnsPluralized = minTurns === 1 ? 'turn' : 'turns';

  const maxTurnStr = ` \nYou may submit as many as ${maxTurns} ${turnsPluralized}.`;

  return (
    <div>
      <Tooltip
        delayDuration={0}
        text={
          <div className="w-60 font-medium text-xs leading-5 whitespace-pre-line">
            {hasAdditionalMinutesPerTurn
              ? `After the first${
                  minTurns === 1 ? '' : ` ${minTurns}`
                } required ${turnsPluralized}, you will receive ${additionalMinutesPerTurn} minutes of additional tasking time for each turn.`
              : `This task requires a minimum of ${minTurns} ${turnsPluralized}.${
                  maxTurns > minTurns ? maxTurnStr : ''
                }`}
          </div>
        }
        target={
          <div
            className="flex items-center gap-2 text-xs font-normal text-mauve-11 ml-2"
            style={{
              color: 'var(--color-mauve-11)',
            }}
          >
            {`${numTurns} / ${minTurns} required ${turnsPluralized}${
              hasAdditionalMinutesPerTurn
                ? ` (+${additionalMinutesPerTurn}m for additional turns)`
                : ''
            }`}
          </div>
        }
      />
    </div>
  );
}

export default memo(InfoTurns);
